'use strict';

var BaseView = require('../../utils/base-view');

module.exports = BaseView.extend({
    propertyHandlers: [

    ],

    initialize: function () {
    }
}, { selector: '*' });



// WEBPACK FOOTER //
// ./src/dom/node-manager/default-node.js